import { NodeModel } from "../_model/NodeModel";
import { Types } from "../../utils/nodeTypes"
import { DecorationCircle } from "./decorationCircle"
import Properties from "../_model/ModelEngineeringProperties";

class Circle extends NodeModel{
  constructor() {
    super("Circle")
    this.type = new Types().Circle
    this.x = 0;
    this.y = 0;
    this.xCircle = () => this.x + 25
    this.yCircle = () => this.y + 25
    this.radius = 20
    this.height = 50
    this.width = 50
    
    this.decorate = function() {
      this.decorator = new DecorationCircle()
      this.decorator.init(this)
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map(d => new Properties({...d }));
      this.CurrentTempAr = node.CurrentTempAr
  }

    this.clone = function() {
      let cloned = new Circle();
      cloned.id = this.id
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.radius = this.radius
      cloned.expressionVisible = this.expressionVisible
      return cloned;
    }
  }
}

export { Circle };
